import _ from 'lodash';
import { types } from 'domain/Options/generators/shapes';
import messages from './messages';
import { convertToImperial, convertToMetric } from '../../../domain/Options/utils/convertMeasurement';

export function calcOverhangMeasurementsError(dimensions, overhangWithWorktopDimensions, minLength, maxLength, overhangSideOption, shape, useImperialUnits) {
  const errors = [];

  _.forEach(dimensions, (dimension, dimensionName) => {
    if (dimension !== null && dimension < minLength) {
      let tempMinLength;
      if (useImperialUnits) {
        tempMinLength = convertToImperial(minLength);
      } else {
        tempMinLength = minLength;
      }
      const minLengthVal = tempMinLength;
      errors.push({
        fields: [dimensionName],
        message: {
          ...(
            useImperialUnits
            ? messages.errorMinimumImperial
            : messages.errorMinimum
          ),
          values: {
            value: minLengthVal,
          },
        },
      });
    }
  });

  const shapeDimensions = shape && shape.getIn(['value', 'dimensions']);
  if (shapeDimensions) {
    _.forEach(overhangWithWorktopDimensions, (dimension, dimensionName) => {
      const type = shapeDimensions.getIn([dimensionName, 'type']);
      let maxLimit;
      if (useImperialUnits) {
        const imperialValMax = convertToImperial(maxLength);
        const diffMax = convertToMetric(imperialValMax) - maxLength;
        maxLimit = maxLength + diffMax;
      } else {
        maxLimit = maxLength;
      }
      if (type === types.LENGTH && dimension > maxLimit) {
        const fields = overhangSideOption.get('dimensions').reduce((dims, value, key) => {
          if (dimensionName === value.get('length')) {
            return [...dims, key];
          }

          return dims;
        }, []);
        let tempMaxLength;
        if (useImperialUnits) {
          tempMaxLength = convertToImperial(maxLength);
          let convertedMessage = messages.errorOverhangMaximum.defaultMessage.toString();
          convertedMessage = convertedMessage.replace('mm', 'in');
          messages.errorOverhangMaximum.defaultMessage = convertedMessage;
        } else {
          tempMaxLength = maxLength;
        }
        const maxLengthVal = tempMaxLength;
        errors.push({
          fields,
          message: {
            ...(
              useImperialUnits
              ? messages.errorOverhangMaximumImperial
              : messages.errorOverhangMaximum
            ),
            values: {
              value: maxLengthVal,
            },
          },
        });
      }
    });
  }

  return errors;
}

export function calcIrregularMeasurementsError(shapeMeasurements, overhangSides, overhangDimensions, overhangWithWorktopDimensions, minDepth, maxDepth, minLength, maxLength, overhangDefaultSize, useImperialUnits) {
  const errors = [];
  _.forEach(overhangDimensions, (dimension, dimensionName) => {
    const a = shapeMeasurements.get('a');
    const extendedSide = overhangSides.getIn(['dimensions', dimensionName, 'depth']);
    const extendedSideMeasurement = shapeMeasurements.get(extendedSide);
    const otherSideMeasurement = extendedSide === 'b' ? shapeMeasurements.get('c') : shapeMeasurements.get('b');
    const condition = extendedSideMeasurement < otherSideMeasurement ? minDepth : maxDepth;
    const overhangMax = Math.floor(Math.abs(extendedSideMeasurement - condition) * (a / Math.abs((otherSideMeasurement - extendedSideMeasurement))));

    if ((dimension || overhangDefaultSize) > overhangMax) {
      errors.push({
        fields: [dimensionName],
        message: {
          ...(
            useImperialUnits 
            ? messages.errorMaximumImperial
            : messages.errorMaximum),
          values: {
            value: overhangMax,
          },
        },
      });
    }
  });

  const overhangMeasurementsErrors = calcOverhangMeasurementsError(overhangDimensions, overhangWithWorktopDimensions, minLength, maxLength, overhangSides);
  return errors.concat(overhangMeasurementsErrors);
}
